import { useMutation, UseMutationResult, useQueryClient } from "@tanstack/react-query";
import axios from "axios";
import { enum_api_uri } from "../../../utils/enum";
import { useAuthStore } from "../../../../../console/store/useAuthStore";

interface DeleteGoodsRequest {
    product_idx: number[];
}

export const useDeleteGoods = (successCallback?: () => void): UseMutationResult<null, Error, DeleteGoodsRequest, unknown> => {
    const queryClient = useQueryClient();
    const accessToken = useAuthStore(state => state.accessToken);

    return useMutation<null, Error, DeleteGoodsRequest>({
        mutationFn: async (deleteData: DeleteGoodsRequest) => {
            const response = await axios.request({
                method: "DELETE",
                url: `${enum_api_uri.delete_product}`,
                data: deleteData,
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                    "Content-Type": "application/json",
                },
            });
            return response.data;
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ["getGoodsList"] });
            successCallback?.();
        },
    });
};
